import { spawn, type ChildProcess } from 'node:child_process';
import type { PreviewEnvironmentProcessLifecycle } from '../process-lifecycle.js';
import { isSpawnEbadf, mergePreviewEnvironmentSpawnOptions } from './utils.js';

/**
 * `spawn(command, { shell: true, stdio: [devNull, pipe, pipe] })` — alternate libuv path vs `/bin/sh -c`.
 */
export function trySpawnShellTruePiped(
  command: string,
  env: NodeJS.ProcessEnv,
  cwd: string,
  devNullFd: number,
  signal?: AbortSignal,
  lifecycle?: PreviewEnvironmentProcessLifecycle,
): ChildProcess | null {
  try {
    const opts = mergePreviewEnvironmentSpawnOptions(
      {
        env,
        cwd,
        stdio: [devNullFd, 'pipe', 'pipe'],
        shell: true,
        ...(signal ? { signal } : {}),
      },
      lifecycle,
    );
    if (process.platform === 'win32') {
      opts.windowsHide = true;
    }
    return spawn(command, opts);
  } catch (e) {
    if (isSpawnEbadf(e)) return null;
    throw e;
  }
}
